import { useEffect, useState } from 'react';

const useGetReportCount = (reportDetails) => {
  const [counts, setCounts] = useState({
    total: null,
    completed: null,
    inProgress: null,
    totalViewCount: null,
    totalAppointments: null,
  });

  useEffect(() => {
    if (!reportDetails || reportDetails.length === 0) {
      setCounts({
        total: null,
        completed: null,
        inProgress: null,
        totalViewCount: null,
        totalAppointments: null,
      });
      return;
    }

    let totalCount = 0;
    let completedCount = 0;
    let totalViewCount = 0;
    let totalAppointments = 0;

    reportDetails?.forEach((report) => {
      const appointments = report?.appointments || [];
      appointments?.forEach((appointment) => {
        const summary = appointment?.labResults?.summary || {};
        const { totalLabRecordsCount = 0, availableLabRecordsCount = 0, isLabReportsViewed = false } = summary;
        totalCount += totalLabRecordsCount;
        completedCount += availableLabRecordsCount;
        totalAppointments += 1;
        if (isLabReportsViewed) {
          totalViewCount += 1;
        }
      });
    });

    const inProgressCount = totalCount - completedCount;
    setCounts({
      total: totalCount,
      completed: completedCount,
      inProgress: inProgressCount,
      totalViewCount,
      totalAppointments,
    });
  }, [reportDetails]);

  return counts;
};

export default useGetReportCount;
